export const ProductName = "ITOEX"